import React from 'react';
import Loading from './Loading';

export default function LoadingContainer() {
  return (
    <div className="module-calling">
      <div className="loading-container">
        <Loading />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/LoadingContainer.js